import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { post_Event } from '../../services/Event';
import { formatUSPhone, handleUSPhoneChange } from '../../utils/phoneFormatter';
import { useUSPhoneValidation } from '../../hook/useUSPhoneValidation';
import useGroup from '../../hook/useGroup';
import useSubGroup from '../../hook/useSubGroup';
import EmailFormatValidation from '../../components/EmailFormatValidation';
import CustomDateTimePicker from '../../components/CustomDateTimePicker';
import moment from 'moment';
import Cookies from 'js-cookie';

const AddEvent = () => {
    const token = Cookies.get("token-my-cdir");
    const navigate = useNavigate();
    const { selectedGroupId }: any = useGroup();
    const { allSubGroups, selectedSubGroupId, setSelectedSubGroupId }: any = useSubGroup();
    const [userData, setUserData] = useState<any>({
        eventName: "",
        groupId: 0,
        subGroupId: 0,
        startDate: "",
        endDate: "",
        sessions: "",
        eventCoordinatorNameEmailAddress: "",
        eventCoordinatorEmail: "",
        eventCoordinatorPhone: "",
        guest: "",
        description: "",
        isActive: true,
        location: ""
    });
    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const [dateTouched, setDateTouched] = useState<
        "startDate" | "endDate" | ""
    >("");

    const isDateInvalid =
        userData.startDate &&
        userData.endDate &&
        moment(userData.endDate).isSameOrBefore(moment(userData.startDate));

    const {
        isValid: isPhoneValid,
        touched: phoneTouched,
        setTouched: setPhoneTouched
    } = useUSPhoneValidation(userData.eventCoordinatorPhone);

    const closeModal = () => navigate(-1);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!isProcessing) {
            setIsProcessing(true);

            post_Event({
                ...userData,
                groupId: selectedGroupId,
                subGroupId: selectedSubGroupId
            }, token!.toString())
                .then(() => {
                    setIsProcessing(false);
                    navigate(-1);
                })
                .catch(error => {
                    setIsProcessing(false);
                    console.error(error);
                });
        }
    }

    return (
        <div className="w-full">
            <div className="my-2">
                <div className="py-8 px-6 relative bg-white">
                    <h2 className="text-xl text-secondary font-bold">Add Event</h2>
                    <form onSubmit={handleSubmit} className="mt-8 grid xm:grid-cols-2 gap-6 text-secondary">
                        <div>
                            <label className="font-semibold text-sm">Event Name</label>
                            <input type='text' placeholder='Enter Event Name'
                                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                                value={userData.eventName}
                                onChange={(e) => setUserData({ ...userData, eventName: e.target.value })}
                                required
                            />
                        </div>
                        <div>
                            <label className="font-semibold text-sm">Event Coordinator Name</label>
                            <input type='text' placeholder='Enter Event Coordinator Name'
                                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                                value={userData.eventCoordinatorNameEmailAddress}
                                onChange={(e) => setUserData({ ...userData, eventCoordinatorNameEmailAddress: e.target.value })}
                                required
                            />
                        </div>

                        <EmailFormatValidation
                            text={userData.eventCoordinatorEmail}
                            setText={(value) =>
                                setUserData({
                                    ...userData,
                                    eventCoordinatorEmail: value
                                })
                            }
                            label="Event Coordinator Email"
                            placeholder="Enter Event Coordinator Email"
                            className={{
                                parentDiv: "",
                                label: "font-semibold text-sm",
                                input:
                                    "w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                            }}
                            required
                        />

                        <div>
                            <label className="font-semibold text-sm">Event Coordinator Phone Number</label>
                            <input
                                type="tel"
                                name="phone"
                                value={formatUSPhone(userData.eventCoordinatorPhone)}
                                onChange={(e) => {
                                    setPhoneTouched(true);
                                    handleUSPhoneChange(e, (digits) =>
                                        setUserData((prev: any) => ({
                                            ...prev,
                                            eventCoordinatorPhone: digits,
                                        }))
                                    );
                                }}
                                required
                                className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                                placeholder="Enter Event Coordinator Phone No."
                            />

                            {!isPhoneValid && phoneTouched && (
                                <p className="text-xs text-red-500 mt-1">
                                    Please enter a valid 10-digit phone number
                                </p>
                            )}
                        </div>

                        <div>
                            <label className="font-semibold text-sm">Ministries</label>
                            <select
                                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                                value={selectedSubGroupId}
                                onChange={(e) => setSelectedSubGroupId(parseInt(e.target.value))}
                                required
                            >
                                <option value={0}>All</option>
                                {
                                    allSubGroups?.map((item: any, index: number) => (
                                        <option
                                            key={index}
                                            value={item?.value}
                                        >
                                            {item?.label}
                                        </option>
                                    ))
                                }
                            </select>
                        </div>

                        <div className='max-xm:hidden' />

                        <div>
                            <label className="font-semibold text-sm">
                                Start Date
                            </label>

                            <CustomDateTimePicker
                                value={userData.startDate}
                                maxDate="9999-12-31T23:59"
                                onChange={(value) => {

                                    setDateTouched("startDate");

                                    setUserData({
                                        ...userData,
                                        startDate: value,
                                    });

                                }}
                                required
                            />

                            {isDateInvalid &&
                                dateTouched === "startDate" && (
                                    <p className="text-xs text-red-500 mt-1">
                                        Event Start Date must be less than Event End Date.
                                    </p>
                                )}
                        </div>

                        <div>
                            <label className="font-semibold text-sm">
                                End Date
                            </label>

                            <CustomDateTimePicker
                                value={userData.endDate}
                                maxDate="9999-12-31T23:59"
                                onChange={(value) => {

                                    setDateTouched("endDate");

                                    setUserData({
                                        ...userData,
                                        endDate: value,
                                    });

                                }}
                                required
                            />

                            {isDateInvalid &&
                                dateTouched === "endDate" && (
                                    <p className="text-xs text-red-500 mt-1">
                                        Event End Date must be greater than Event Start Date.
                                    </p>
                                )}
                        </div>

                        <div>
                            <label className="font-semibold text-sm">Guest</label>
                            <input type='text'
                                className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                                value={userData.guest}
                                onChange={(e) => setUserData({ ...userData, guest: e.target.value })}
                                required
                            />
                        </div>
                        <div>
                            <label className="font-semibold text-sm">Sessions</label>
                            <input type='text'
                                className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                                value={userData.sessions}
                                onChange={(e) => setUserData({ ...userData, sessions: e.target.value })}
                                required
                            />
                        </div>
                        <div>
                            <label className="font-semibold text-sm">Location</label>
                            <input type='text'
                                className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                                value={userData.location}
                                onChange={(e) => setUserData({ ...userData, location: e.target.value })}
                                required
                            />
                        </div>
                        <div>
                            <label className="font-semibold text-sm">Active</label>
                            <div className="flex items-center font-semibold text-sm gap-4  h-1/2">
                                <div className="flex items-center gap-2">
                                    <input
                                        type="radio"
                                        value="Yes"
                                        name="active"
                                        style={{ fontSize: "12px" }}
                                        checked={userData.isActive ? true : false}
                                        onChange={(e) => setUserData({ ...userData, isActive: e.target.value === "Yes" ? true : false })}
                                    />
                                    <label>Yes</label>
                                </div>
                                <div className="flex items-center gap-2">
                                    <input
                                        type="radio"
                                        value="No"
                                        name="active"
                                        style={{ fontSize: "12px" }}
                                        checked={userData.isActive ? false : true}
                                        onChange={(e) => setUserData({ ...userData, isActive: e.target.value === "Yes" ? true : false })}
                                    />
                                    <label>No</label>
                                </div>
                            </div>
                        </div>

                        <div>
                            <label className="font-semibold text-sm">Description</label>
                            <textarea placeholder='Description'
                                className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                                value={userData.description}
                                onChange={(e) => setUserData({ ...userData, description: e.target.value })}
                            />
                        </div>
                        <div />

                        <div className="flex max-xm:flex-col gap-4 !mt-4">
                            <button
                                type="button"
                                className="px-6 py-2 min-w-[150px] rounded text-black text-sm font-semibold border-none outline-none bg-gray-200 hover:bg-gray-300 active:bg-gray-200"
                                onClick={closeModal}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                disabled={isDateInvalid}
                                className="px-6 py-2 min-w-[150px] rounded text-white text-sm font-semibold border-none outline-none bg-secondary hover:bg-custom-blue"
                            >
                                {isProcessing ?
                                    <>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18px" fill="#fff" className="mr-2 inline animate-spin"
                                            viewBox="0 0 26.349 26.35">
                                            <circle cx="13.792" cy="3.082" r="3.082" data-original="#000000" />
                                            <circle cx="13.792" cy="24.501" r="1.849" data-original="#000000" />
                                            <circle cx="6.219" cy="6.218" r="2.774" data-original="#000000" />
                                            <circle cx="21.365" cy="21.363" r="1.541" data-original="#000000" />
                                            <circle cx="3.082" cy="13.792" r="2.465" data-original="#000000" />
                                            <circle cx="24.501" cy="13.791" r="1.232" data-original="#000000" />
                                            <path
                                                d="M4.694 19.84a2.155 2.155 0 0 0 0 3.05 2.155 2.155 0 0 0 3.05 0 2.155 2.155 0 0 0 0-3.05 2.146 2.146 0 0 0-3.05 0z"
                                                data-original="#000000" />
                                            <circle cx="21.364" cy="6.218" r=".924" data-original="#000000" />
                                        </svg>
                                        Processing...
                                    </>
                                    :
                                    "Save"
                                }
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AddEvent